import React, { Component } from 'react';
import { Button, Form, Grid, Input, Label, Icon } from 'semantic-ui-react';
import { isBrowser } from 'react-device-detect';
import { toastr } from 'react-redux-toastr';

class InPlacePromCode extends Component {
  state = {
    promocode: '',
    applied: false
  };

  applyPromoCode = e => {
    if (e)
      e.stopPropagation();
    const { promocode } = this.state;
    const { addMoneyForm, applyPromoCode, auth } = this.props;
    if (!!promocode) {
      applyPromoCode(
        promocode,
        addMoneyForm.values && addMoneyForm.values['txn_amount'],
        auth.csrfRequestIdentifier,
        response => {
          if (response.errorCode && response.errors) {
            this.setState({ promocode: '' });
          }

          if (response.successMsg === 'success') {
            this.setState({ applied: true });
          }

          this.toggleForm();
        }
      );
    } else {
      toastr.error('Error', 'Please enter promo code');
    }
  };

  resetPromoCode = e => {
    e.preventDefault();
    const { promocode } = this.state;
    const { resetPromoCode } = this.props;

    if (!!promocode) {
      resetPromoCode(() => {
        this.setState({ applied: false, promocode: '' });
      });
    }
  };

  handleChange = e => {
    this.setState({ promocode: e.target.value });
  };

  toggleForm = e => {
    if (e)
      e.stopPropagation();
    // toggle show form state
    this.props.toggle();

    //
    this.setState({
      promocode: ''
    });

    // set focus to input field
    if (this.inputRef && typeof this.inputRef.focus === 'function')
      this.inputRef.focus();
  };
  render() {
    const { applied, promocode } = this.state;
    const {
      async,
      input,
      width,
      placeholder,
      meta: { touched, error },
      show
    } = this.props;
    return (
      <Form.Field error={touched && !!error} width={width}>
        <Grid style={{ marginBottom: '10px' }}>
          <Grid.Row>
            <Grid.Column width={isBrowser ? 11 : 1} />
            <Grid.Column width={isBrowser ? 5 : 10}>
              {!show && !applied && (
                <Button
                  className="floatRight buttonLink"
                  onClick={this.toggleForm}
                  style={{ height: '20px' }}
                >
                  Apply promocode!
                </Button>
              )}
              {applied && (
                <React.Fragment>
                  <Button
                    className="floatRight buttonLink"
                    style={{ height: '20px' }}
                    onClick={this.resetPromoCode}
                  >
                    {' '}
                    <Label as="a" color="green">
                      Promocode: {promocode}
                      <Icon name="delete" />
                    </Label>
                  </Button>
                </React.Fragment>
              )}

              {show && !applied && (
                <Input
                  {...input}
                  value={promocode}
                  placeholder={
                    placeholder
                  }
                  onChange={this.handleChange}
                  onKeyPress={e => {
                    const key=e.keyCode || e.which;
                    if (key === 13) {
                      e.preventDefault();
                      this.applyPromoCode();
                    }
                  }}
                  error={false}
                  ref={input => {
                    this.inputRef = input;
                  }}
                  onClick={e => e.stopPropagation()}
                  label={
                    <React.Fragment>
                      <Button
                        color="green"
                        icon="check"
                        attached="right"
                        name="promo-code"
                        loading={
                          (async.key === 'applypromocode' && async.loading)
                        }
                        style={{ borderRadius: 0 }}
                        onClick={this.applyPromoCode}
                      />
                      <Button
                        color="red"
                        icon="close"
                        attached="right"
                        onClick={this.toggleForm}
                      />
                    </React.Fragment>
                  }
                  labelPosition="right"
                />
              )}
              {touched && error && (
                <Label basic color="red">
                  {error}
                </Label>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Field>
    );
  }
}

export default InPlacePromCode;
